import React, { useEffect, useContext } from "react";

import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { TitleTable } from "../../../components/basic/TitleTable";
import TextFieldCustom from "../../../components/basic/TextFieldCustom";
import Btn from "../../../components/buttons/Btn";
import api from "../../../services/api";
import { GlobalVariables } from "../../../global";
import { UserContext } from "../../../context/UserContext";
import { notify } from "../../../utils/notify";
import MaskService from "../../../utils/mask/maskService";
import { formatDateAmerican } from "../../../utils/formatDate";
import { GridStyled } from "../../../styles/GlobalStyle";
import { CustomerContext } from "../contexts/CustomerContext";
import useProductController from "../controllers/ProductController";
import SelectCustom from "../../../components/basic/SelectCustom";
import { getVolumetries } from "../../../repositories/v1/volumetry";

export default function FormProduct({ state }) {
  const { user } = useContext(UserContext);
  const {
    documentType,
    cnpj,
    birthDate,
    products,
    setProducts,
    optionsFamily,
    setOptionsFamily,
    optionsProducts,
    setOptionsProducts,
    optionsVersions,
    setOptionsVersions,
    optionsCancellation,
    setOptionsCancellation,
    listVolumetries,
    setListVolumetries,
    maps,
    setMaps,
    errors,
    setLoadings,
  } = useContext(CustomerContext);
  const {
    handleEditProduct,
    handleAddProduct,
    handleChangeItem,
    productIsTrial,
    handleCurrentBoxAndUncheckOthers,
  } = useProductController();

  useEffect(() => {
    if (documentType === "cpf" && !state && !birthDate) return;

    const documentsLength = {
      cnpj: 14,
      cpf: 11,
    };
    if (
      !cnpj ||
      cnpj.replace(/[^0-9]+/g, "").length !== documentsLength[documentType]
    )
      return;

    (async () => {
      try {
        setLoadings((current) => ({ ...current, screen: true }));

        const cnpjRemoveMask = cnpj;

        const { data } = await api.get(
          `mapa/dadosProdutos/cliente/${cnpjRemoveMask.replace(/[^0-9]+/g, "")}`
        );

        data.cancellationReasons.unshift({ Id: 0, Descricao: "" });
        data.families.unshift({ Id: 0, Descricao: "" });
        data.products.unshift({ Id: 0, Descricao: "" });
        data.versions.unshift({
          Id: 0,
          Descricao: "",
          IdTipoPromotorAcesso: "",
        });

        data.maps.push({
          Id: 0,
          IdFamilia: 0,
          IdProduto: 0,
          IdVersao: 0,
          Rota: "",
          IdTipoPromotor: 0,
          IdUsuario: 0,
          DataExpiracao: "",
          DataCancelamento: "",
          DataBloqueio: "",
          DataConsultaLimite: "",
          Demo: false,
          Trial: false,
          Freemium: false,
          ValoresParametros: {},
          IdMotivoCancelamento: 0,
          Volumetrias: [],
        });

        setOptionsCancellation(data.cancellationReasons);
        setOptionsFamily(data.families);
        setOptionsProducts(data.products);
        setOptionsVersions(data.versions);
        setMaps(data.maps);
      } catch (error) {
        console.error(error);
        notify("Não foi possível obter os produtos deste cliente.");
      } finally {
        setLoadings((current) => ({ ...current, screen: false }));
      }
    })();
  }, [
    cnpj,
    documentType,
    setLoadings,
    setOptionsCancellation,
    setOptionsFamily,
    setOptionsProducts,
    setOptionsVersions,
    setProducts,
    setMaps,
    state,
    birthDate,
  ]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await getVolumetries();

        if (Array.isArray(data?.data)) {
          data.data.forEach((v) => {
            v.id = v.Id;
          });

          setListVolumetries(data.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
      }
    })();
  }, [setListVolumetries]);

  useEffect(() => {
    try {
      if (!listVolumetries.length) return;

      const copy = [...maps];

      copy.forEach((p) => {
        if (!Array.isArray(p.IdsVolumetriaLimites)) {
          p.IdsVolumetriaLimites = [];
        }

        p.Volumetrias = listVolumetries.filter((v) =>
          p.IdsVolumetriaLimites.includes(v.Id)
        );
      });

      setProducts(copy);
    } catch (error) {
      console.error(error);
    }
  }, [listVolumetries, maps, setProducts]);

  return (
    <>
      <Grid item xs={12}>
        <TitleTable title="Produtos" />
      </Grid>

      <Grid item container spacing={2} alignItems="center">
        {products.map((item, index) => {
          let paramsCurrent = handleChangeItem({
            item,
          });
          const isLastItem = index === products.length - 1;
          const isNotErpProAdittional =
            item.IdVersao !== GlobalVariables.ID_VERSAO_ERP_PRO_ADICIONAL;

          return (
            <Grid
              className="cardProduct"
              key={index}
              container
              alignItems="center"
              justify="center"
            >
              <Grid
                item
                container
                alignItems="center"
                justify="center"
                spacing={2}
                xs={11}
              >
                {index !== products.length - 1 && (
                  <Grid item lg={3} md={6} sm={6} xs={12}>
                    <TextField
                      style={{ width: "100%" }}
                      select
                      label="Motivo Cancelamento"
                      value={item.IdMotivoCancelamento || ""}
                      error={
                        index === errors.index && errors.IdMotivoCancelamento
                      }
                      onChange={(e) => {
                        const copyProducts = [...products];
                        const copyItem = { ...item };

                        copyItem.IdMotivoCancelamento = e.target.value;
                        copyItem.DataCancelamento = new Date()
                          .toISOString()
                          .split("T")[0];

                        copyProducts[index] = copyItem;
                        setProducts(copyProducts);
                      }}
                    >
                      {optionsCancellation.map((option) => (
                        <MenuItem key={option.Id} value={option.Id}>
                          {option.Descricao}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}

                {!!(
                  index !== products.length - 1 && item.IdMotivoCancelamento
                ) && (
                  <>
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <TextFieldCustom
                        style={{ width: "100%" }}
                        label="Data do Cancelamento*"
                        type="date"
                        value={item.DataCancelamento || ""}
                        error={
                          index === errors.index && errors.DataCancelamento
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                      />
                    </Grid>

                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <TextFieldCustom
                        style={{ width: "100%" }}
                        label="Data Bloqueio da Base*"
                        type="date"
                        value={item.DataBloqueio || ""}
                        error={index === errors.index && errors.DataBloqueio}
                        onChange={(e) => {
                          const copyProducts = [...products];
                          const copyItem = { ...item };

                          copyItem.DataBloqueio = e.target.value;

                          copyProducts[index] = copyItem;
                          setProducts(copyProducts);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>

                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <TextFieldCustom
                        style={{ width: "100%" }}
                        label="Data Limite de Consulta*"
                        type="date"
                        value={item.DataConsultaLimite || ""}
                        error={
                          index === errors.index && errors.DataConsultaLimite
                        }
                        onChange={(e) => {
                          const copyProducts = [...products];
                          const copyItem = { ...item };

                          copyItem.DataConsultaLimite = e.target.value;

                          copyProducts[index] = copyItem;
                          setProducts(copyProducts);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </>
                )}

                <Grid item lg={3} md={6} sm={6} xs={12}>
                  <TextField
                    style={{ width: "100%" }}
                    select
                    disabled={index !== products.length - 1}
                    label="Família*"
                    value={item.IdFamilia}
                    error={index === errors.index && errors.IdFamilia}
                    onChange={(e) => {
                      const copyProducts = [...products];
                      const copyItem = { ...item };

                      copyItem.IdFamilia = e.target.value;
                      copyItem.IdProduto = 0;
                      copyItem.IdVersao = 0;
                      copyItem.Rota = "";
                      copyItem.Volumetrias = [];

                      copyProducts[index] = copyItem;
                      setProducts(copyProducts);
                    }}
                  >
                    {optionsFamily.map((option) => (
                      <MenuItem key={option.Id} value={option.Id}>
                        {option.Descricao}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item lg={3} md={4} sm={6} xs={12}>
                  <TextField
                    style={{ width: "100%" }}
                    disabled={index !== products.length - 1}
                    select
                    label="Produto*"
                    value={item.IdProduto}
                    error={index === errors.index && errors.IdProduto}
                    onChange={(e) => {
                      const copyProducts = [...products];
                      const copyItem = { ...item };

                      copyItem.IdProduto = e.target.value;
                      copyItem.IdVersao = 0;
                      copyItem.Rota = "";
                      copyItem.Volumetrias = [];

                      copyProducts[index] = copyItem;
                      setProducts(copyProducts);
                    }}
                  >
                    {optionsProducts.map((option) => {
                      if (
                        option.Id === 0 ||
                        (item.IdFamilia && option.IdFamilia === item.IdFamilia)
                      ) {
                        return (
                          <MenuItem key={option.Id} value={option.Id}>
                            {option.Descricao}
                          </MenuItem>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </TextField>
                </Grid>

                <Grid item lg={3} md={4} sm={6} xs={12}>
                  <TextField
                    style={{ width: "100%" }}
                    className="textFieldPromocode"
                    disabled={
                      index !== products.length - 1 &&
                      !user.accessRoutes.includes("/updateVersionMap")
                    }
                    select
                    label="Versão*"
                    value={item.IdVersao}
                    error={index === errors.index && errors.IdVersao}
                    onChange={(e) => {
                      const versionSelect = optionsVersions.find(
                        (v) => v.Id === e.target.value
                      );
                      const copyProducts = [...products];
                      const copyItem = { ...item };

                      copyItem.IdVersao = e.target.value;

                      copyItem.Volumetrias = listVolumetries.filter((v) =>
                        v.IdsVersao.includes(e.target.value)
                      );

                      const sameFamilyProduct = products.find((product) => {
                        return product.IdFamilia === item.IdFamilia;
                      });

                      if (versionSelect && versionSelect.ValoresPadrao) {
                        try {
                          copyItem.ValoresParametros = JSON.parse(
                            versionSelect.ValoresPadrao
                          );
                        } catch (error) {
                          copyItem.ValoresParametros = {};
                          item.IdVersao = 0;
                          notify(
                            "Não foi possível exibir parâmetros do produto."
                          );
                        }
                      } else {
                        if (sameFamilyProduct?.ValoresParametros) {
                          copyItem.ValoresParametros =
                            sameFamilyProduct.ValoresParametros;
                        } else {
                          copyItem.ValoresParametros = {};
                        }
                      }

                      if (
                        copyItem.IdFamilia ===
                          GlobalVariables.ID_FAMILIA_PONTO &&
                        !copyItem.Rota
                      ) {
                        copyItem.Rota = sameFamilyProduct.Rota;
                      }

                      if (isLastItem) copyItem.Trial = true;

                      copyItem.Freemium = false;

                      const dateExpiration = new Date();
                      if (
                        versionSelect &&
                        (versionSelect.DiasTrial ||
                          versionSelect.DiasTrial === 0)
                      ) {
                        dateExpiration.setDate(
                          dateExpiration.getDate() + versionSelect.DiasTrial
                        );
                        copyItem.DataExpiracao =
                          formatDateAmerican(dateExpiration);
                      }

                      copyProducts[index] = copyItem;
                      setProducts(copyProducts);
                    }}
                  >
                    {optionsVersions.map((option) => {
                      if (
                        option.Id === 0 ||
                        ((index !== products.length - 1 ||
                          option.IdTipoPromotorAcesso) &&
                          item.IdProduto &&
                          option.IdProduto === item.IdProduto)
                      ) {
                        return (
                          <MenuItem key={option.Id} value={option.Id}>
                            {option.Descricao}
                          </MenuItem>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </TextField>
                </Grid>

                {isNotErpProAdittional && !isLastItem && (
                  <Grid item lg={3} md={4} sm={12} xs={12}>
                    <TextFieldCustom
                      label="Nome de Acesso*"
                      type="text"
                      disabled={!isLastItem}
                      value={item.Rota}
                      error={index === errors.index && errors.Rota}
                      onChange={(e) => {
                        const copyProducts = [...products];
                        const copyItem = { ...item };
                        copyItem.Rota = e.target.value

                        copyProducts[index] = copyItem;
                        setProducts(copyProducts);
                      }}
                    />
                  </Grid>
                )}

                {isNotErpProAdittional && (
                  <Grid item lg={2} md={2} sm={2} xs={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={item.Demo}
                          onChange={() => {
                            const copyProducts = [...products];
                            const copyItem = { ...item };

                            copyProducts[index] =
                              handleCurrentBoxAndUncheckOthers(
                                "Demo",
                                copyItem
                              );

                            setProducts(copyProducts);
                          }}
                          name="demo"
                          className="checkboxColor"
                        />
                      }
                      label="Demo"
                    />
                  </Grid>
                )}

                {isNotErpProAdittional && (
                  <Grid item lg={2} md={2} sm={2} xs={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={
                            user.IdTipoUsuario !== GlobalVariables.ADM_QYON
                          }
                          checked={item.Freemium}
                          onChange={() => {
                            const copyProducts = [...products];
                            const copyItem = { ...item };

                            copyProducts[index] =
                              handleCurrentBoxAndUncheckOthers(
                                "Freemium",
                                copyItem
                              );

                            setProducts(copyProducts);
                          }}
                          name="checkedB"
                          className="checkboxColor"
                        />
                      }
                      label="Freemium"
                    />
                  </Grid>
                )}

                {isNotErpProAdittional && (
                  <Grid item lg={2} md={2} sm={2} xs={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={
                            !isLastItem ||
                            user.IdTipoUsuario !== GlobalVariables.ADM_QYON
                          }
                          checked={productIsTrial(item)}
                          onChange={() => {
                            const copyProducts = [...products];
                            const copyItem = { ...item };

                            copyProducts[index] =
                              handleCurrentBoxAndUncheckOthers(
                                "Trial",
                                copyItem
                              );

                            if (!productIsTrial(copyProducts[index])) {
                              copyProducts[index].DataExpiracao = null;
                            }
                            setProducts(copyProducts);
                          }}
                          name="checkedB"
                          className="checkboxColor"
                        />
                      }
                      label="Trial"
                    />
                  </Grid>
                )}

                {!isLastItem && isNotErpProAdittional && (
                  <Grid item lg={2} md={2} sm={2} xs={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled
                          checked={item.Tester}
                          className="checkboxColor"
                          onChange={() => {
                            const copyProducts = [...products];
                            const copyItem = { ...item };

                            copyProducts[index] =
                              handleCurrentBoxAndUncheckOthers(
                                "Tester",
                                copyItem
                              );
                            setProducts(copyProducts);
                          }}
                        />
                      }
                      label="Tester"
                    />
                  </Grid>
                )}

                {productIsTrial(item) && isNotErpProAdittional && (
                  <Grid item lg={3} md={4} sm={6} xs={7}>
                    <TextFieldCustom
                      style={{ width: "100%" }}
                      label="Data Expiração Trial*"
                      type="date"
                      disabled={
                        user.IdTipoUsuario !== GlobalVariables.ADM_QYON ||
                        item.ValoresParametros?.numberTrialDateChanges >=
                          GlobalVariables.MAXIMUM_TRIAL_DATE_CHANGES
                      }
                      value={item.DataExpiracao || ""}
                      error={index === errors.index && errors.DataExpiracao}
                      onChange={(e) => {
                        const copyProducts = [...products];
                        const copyItem = { ...item };

                        copyItem.DataExpiracao = e.target.value;

                        copyProducts[index] = copyItem;
                        setProducts(copyProducts);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                )}

                {paramsCurrent.map((element, indexParams) => {
                  if (element.isFlag) {
                    return (
                      <Grid
                        item
                        lg={3}
                        md={4}
                        sm={12}
                        xs={12}
                        key={indexParams}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={
                                user.IdTipoUsuario !==
                                  GlobalVariables.ADM_QYON && element.default
                                  ? true
                                  : false
                              }
                              checked={
                                item?.ValoresParametros?.[element.key] || false
                              }
                              onChange={() => {
                                const copyItem = { ...item };
                                const copyProducts = [...products];
                                copyItem.ValoresParametros[element.key] =
                                  copyItem.ValoresParametros[element.key]
                                    ? false
                                    : true;
                                copyProducts[index] = copyItem;
                                setProducts(copyProducts);
                              }}
                              name="checkedB"
                              className="checkboxColor"
                            />
                          }
                          label={element.label}
                        />
                      </Grid>
                    );
                  }

                  return (
                    <Grid item lg={3} md={4} sm={12} xs={12} key={indexParams}>
                      <TextFieldCustom
                        label={element.label}
                        type={element.type ? element.type : "text"}
                        disabled={
                          user.IdTipoUsuario !== GlobalVariables.ADM_QYON &&
                          element.default
                        }
                        value={
                          element?.mask
                            ? MaskService.toMask(
                                element?.mask,
                                item?.ValoresParametros?.[element.key] || ""
                              )
                            : item?.ValoresParametros?.[element.key] || ""
                        }
                        onChange={(e) => {
                          const copyItem = { ...item };
                          const copyProducts = [...products];

                          if (element.mask) {
                            copyItem.ValoresParametros[element.key] =
                              MaskService.toMask(element.mask, e.target.value);
                          } else {
                            copyItem.ValoresParametros[element.key] =
                              e.target.value;
                          }

                          copyProducts[index] = copyItem;
                          setProducts(copyProducts);
                        }}
                      />
                    </Grid>
                  );
                })}

                {isNotErpProAdittional && (
                  <GridStyled margin="10px 0 0 10" item xs={12}>
                    <SelectCustom
                      disabled={index !== products.length - 1}
                      multiple
                      error={!!(index === errors.index && errors.Volumetrias)}
                      value={item.Volumetrias || []}
                      onChange={(value) => {
                        if (index !== products.length - 1) return;

                        const copyProducts = [...products];
                        const copyItem = { ...item };

                        copyItem.Volumetrias = value;
                        copyProducts[index] = copyItem;

                        setProducts(copyProducts);
                      }}
                      label="Volumetrias"
                      optionsList={listVolumetries.filter((v) =>
                        v.IdsVersao.includes(item.IdVersao)
                      )}
                      keyObject="Descricao"
                    />
                  </GridStyled>
                )}
              </Grid>

              <GridStyled
                margin="15px 0 0 0"
                item
                xs={12}
                container
                alignItems="center"
                justify="center"
              >
                {isLastItem ? (
                  <Grid item container justify="center" spacing={5}>
                    <Grid item flex={1}>
                      <Btn
                        onClick={() => handleAddProduct(true)}
                        label="Gerar Produto"
                      />
                    </Grid>
                    <Grid item flex={1}>
                      <Btn
                        onClick={() => handleAddProduct(false)}
                        bg-color="gray"
                        label="Vincular Produto"
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item container justify="center">
                    <Btn
                      onClick={() => handleEditProduct(index)}
                      bg-color="green"
                      label="Atualizar Produto"
                    />
                  </Grid>
                )}
              </GridStyled>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
